import { render, staticRenderFns } from "./TableRepairHistory.vue?vue&type=template&id=3ca30915&scoped=true"
import script from "./TableRepairHistory.vue?vue&type=script&lang=js"
export * from "./TableRepairHistory.vue?vue&type=script&lang=js"
import style0 from "./TableRepairHistory.vue?vue&type=style&index=0&id=3ca30915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca30915",
  null
  
)

export default component.exports